import { Component, ElementRef, HostListener, inject, input, signal } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { AppLocale, LOCALE_OPTIONS } from '@core/i18n/locale.constants';
import { LocaleService } from '@core/i18n/locale.service';
import { cn } from '@shared/utils/class-names';

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [TranslocoPipe],
  templateUrl: './language-switcher.component.html',
})
export class LanguageSwitcherComponent {
  readonly isDark = input(false);
  readonly presentation = input<'dropdown' | 'pills'>('dropdown');

  private readonly localeService = inject(LocaleService);
  private readonly host = inject(ElementRef<HTMLElement>);

  protected readonly localeOptions = LOCALE_OPTIONS;
  protected readonly cn = cn;
  protected readonly langOpen = signal(false);

  protected get currentLocale(): AppLocale {
    return this.localeService.currentLocale;
  }

  protected localeLabel(code: AppLocale): string {
    return code === 'pt-BR' ? 'PT-BR' : 'EN';
  }

  protected toggleLangMenu(): void {
    this.langOpen.update((value) => !value);
  }

  protected selectLocale(locale: AppLocale): void {
    this.localeService.setLocale(locale);
    this.langOpen.set(false);
  }

  @HostListener('document:mousedown', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.host.nativeElement.contains(event.target as Node)) {
      this.langOpen.set(false);
    }
  }
}
